import { GUIDE_TYPES } from "@/utils/constants/GuidesConstants";

export const isRunning = (sequence = {}) => {
  const { is_enabled, start_date, end_date } = sequence;
  return is_enabled && new Date(start_date) < Date.now() && new Date(end_date) > Date.now();
};

export const canReorder = (sequence = {}) =>
  [GUIDE_TYPES.web_client.value, GUIDE_TYPES.ordered.value, GUIDE_TYPES.tour.value].includes(
    sequence.sequence_type,
  );

/**
 * Returns the device type that all prompts in a sequence must share, or null if there is no lock.
 * Wizards (web_client) derive the lock from the first attached prompt.
 * Survey sequences are always web-only.
 * @param {object|null} sequence
 * @returns {string|null}
 */
export const getLockedDeviceTypeForSequence = sequence => {
  const s = sequence ?? {};
  if (s.sequence_type === GUIDE_TYPES.survey.value) return "web";
  if (s.sequence_type === GUIDE_TYPES.web_client.value) {
    return s.paths?.[0]?.device_type ?? null;
  }
  return null;
};

export const isInvalidSequenceTypeForPromptDevice = (sequence, prompt) => {
  const s = sequence ?? {};
  const p = prompt ?? {};
  if (s.sequence_type === GUIDE_TYPES.survey.value || s.sequence_type === GUIDE_TYPES.tour.value) {
    return p.device_type !== "web";
  }
  if (s.sequence_type === GUIDE_TYPES.web_client.value) {
    const locked = getLockedDeviceTypeForSequence(s);
    return locked !== null && p.device_type !== locked;
  }
  return false;
};
